import { List } from '@mui/material'
import { styled } from '@mui/material/styles'

export const ListContainer = styled(List)`
    // display: flex;
    // flex-direction: column;
`

export default ListContainer
